import { UiSchema } from '@rjsf/utils'

import { FormProperties } from '../imup/types'

export const uiSchema: UiSchema = {
    usage_type: {
        'ui:title': 'Trayed Ceiling and Soffit Type',
        'ui:placeholder': 'Select Type',
    },
    floor_level: {
        'ui:title': 'Trayed Ceiling and Soffit Floor Level',
        'ui:placeholder': 'Select Floor Level',
    },
    floor_level_other: {
        'ui:title': 'Floor level other',
        'ui:placeholder': 'Floor level other',
    },
}

const onValidate = () => {}

const onSubmit = (settings, formData) => {
    const newSettings = { ...settings, ...formData }

    newSettings.floor_level_other = formData.floor_level === 'other' ? formData.floor_level_other : ''

    return newSettings
}

const form: FormProperties = { uiSchema, onValidate, onSubmit }

export default form
